import React from 'react'

export default function Info({children, label}) {
  return (
    <li>
      <span className='info-block-info-label'>{`${label}: `}</span>
      {children}
    </li>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoBlockComponents/Info.js